import React, { PropTypes, Component } from 'react';
import { Chart, Scatter } from 'react-chartjs-2';

class ChartBase extends Component {
    addChartBackground() {
        Chart.pluginService.register({
            beforeDraw: (chart) => {
                var chartArea = chart.chartArea;

                chart.ctx.fillStyle = "rgba(167, 168, 206, .7)";
                chart.ctx.fillRect(chart.scales['x-axis-1'].left,
                    chartArea.top,
                    chart.scales['x-axis-1'].width,
                    chart.scales['y-axis-1'].height);
            }
        });
    }

    progressLoader = () => (<div className="graph-loading">
                                <div className="loader">
                                    <div className="container">
                                        <div className="dot dot-1"></div>
                                        <div className="dot dot-2"></div>
                                        <div className="dot dot-3"></div>
                                    </div>
                                </div>
                                <Scatter data={this.getRandomData()} />
                            </div>);

    infitineToValue = (value) => isFinite(value) ? value : 0;

    getRandomData(showRandomData = true) {
        
        if(showRandomData !== true){
            return { datasets: [] };
        }

        const pointsRandom = [];
        for (let x = 0; x < 31; x++) {
            pointsRandom.push({ x, y: Math.floor(Math.random() * Math.floor(23) + 1) });
        }

        return {
            datasets: [{
                label: Resx.App.Loading,
                data: pointsRandom,
                borderWidth: 1,
                borderColor: 'rgba(242, 96, 96, 1)',
                pointBackgroundColor: 'rgba(242, 96, 96, .7)',
                pointHoverBackgroundColor: 'rgba(242, 96, 96, 1)',
                pointBorderColor: 'rgba(242, 96, 96, .7)',
                pointRadius: 2,
                pointHoverRadius: 4,
                pointBorderWidth: 2,
                backgroundColor: 'rgba(232, 69, 69, .15)',
                fill: true,
                tension: 0,
                showLine: true
            }]
        };
    }
}

export default ChartBase;


// WEBPACK FOOTER //
// ./App/components/modules/chartsBase/chart-base.js